/**
 * Chrome extensions (Urban VPN, etc.) monkey-patch XHR and throw into the page.
 * CRA's overlay treats those as app crashes. Swallow only extension-sourced errors.
 */
const isExtensionNoise = (message = '', filename = '') => {
  const text = `${message} ${filename}`;
  return (
    text.includes('chrome-extension://') ||
    text.includes('moz-extension://') ||
    text.includes("reading 'M_ID'")
  );
};

const ignore = (event) => {
  const message = event.message || event.reason?.message || String(event.reason || '');
  const filename = event.filename || event.reason?.filename || '';
  if (!isExtensionNoise(message, filename)) return;
  event.preventDefault();
  event.stopImmediatePropagation();
};

window.addEventListener('error', ignore, true);
window.addEventListener('unhandledrejection', ignore, true);
